import { render, staticRenderFns } from "./SectionsWrapper.vue?vue&type=template&id=64e29cf2&"
import script from "./SectionsWrapper.vue?vue&type=script&lang=js&"
export * from "./SectionsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports